import NewRole from "./newRole";
export default NewRole;